import { Fragment } from 'react'

import { Session } from '~/types/tutoring-api'

import SessionsLogItem from './SessionsLogItem'

export default function SessionsLogsList({
  completedSessions,
  isTutor,
}: {
  completedSessions: Session[]
  isTutor?: boolean
}): React.ReactElement {
  return (
    <Fragment>
      {completedSessions.map((elem) => (
        <SessionsLogItem
          currentComment={elem.mentorComment}
          id={elem.id}
          isTutor={isTutor}
          key={elem.id}
          name={isTutor ? elem.student?.fullName : elem.mentor?.fullName}
          startTime={elem.startTime}
          type={elem.type}
        />
      ))}
    </Fragment>
  )
}
